import React, { useEffect, useState } from 'react';
import { faPencilAlt, faMapMarkerAlt, faCheck, faFile, faFilePdf, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';

//Components
import IdentificacaoGerador from './components/IdentificacaoGerador';
import MainCard from '../../../components/MainCard/MainCard';
import Stepper from '../../../components/Stepper/Stepper';
import Enderecos from './components/Enderecos';
import FichaGeradorContainer from './components/FichaGeradorContainer';
import TermoCienciaGerador from './components/TermoCienciaGerador';

//Api
import gerador_api from '../../../api/gerador_api';
import documento_api from '../../../api/documento_api';
import prefeitura_api from '../../../api/prefeitura_api';
import geradoresCategoria_api from '../../../api/geradoresCategoria_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import Contratos from './components/Contratos';

//Shared
import Documentos from '../../../views/Shared/Documentos';

//Context
import { useAuth } from '../../../context/auth';
import { useNavigate } from 'react-router-dom';
import { SettingsEthernet } from '@material-ui/icons';

//Estado inicial para o gerador
function initialStateGerador({ prefeitura_id = "" }) {
    return {
        tbPrefeituras_id: prefeitura_id.toString(),
        fantasia: "",
        razao: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        gps: "",
        email: "",
        contato: "",
        fone: "",
        celular: "",
        status: "Ativo",
        tbSegmentos_Id: "",
        tbSegmentos_Descricao: "",
        frequencia: null,
        categoria: "",
        cpfcnpj: "",
        cep: "",
        uf: "",
        cidade: "",
        principalRecipiente: "",
        tbSetores_Id: "",
        tbSetores_Descricao: "",
        caracteristica: "Não Classificado",
        editFicha: true,
        localidades: [],
        vistorias: [],
        dataValidade: "",
        documentos: []
    }
}


export default function NovoGerador({ btnVoltar, geradorParam = {}, prefeitura_id, integracaoCadastros, cadastroExternoGerador = false }) {
    //Estado de controle do loading na tela
    const { session, setupVariavel, setLoading } = useAuth();

    //Estado de controle para os passos do cadastro
    const [activeStep, setActiveStep] = useState(1);

    const navigate = useNavigate();

    //Estado de controle dos campos do gerador
    const [gerador, setGerador] = useState(Object.keys(geradorParam).length > 0 ? geradorParam : initialStateGerador({ prefeitura_id }));

    //Estado para bloquear importação ou não de documento
    const [disabledCampos, setDisbleCampos] = useState(true);

    //Estado de controle dos campos preenchidos incorretamente
    const [errors, setErrors] = useState([]);

    //Estado de controle do formulario de endereço do passo de endereços
    const [openEnderecos, setOpenEnderecos] = useState(false);

    //Estado de controle do formulario de contratos do passo de contratos
    const [openContratos, setOpenContratos] = useState(false);

    //Estado para pegar os documentos para gerador 
    const [listdocumentos, setListDocumentos] = useState([]);

    //Estados para o termo de ciência da prefeitura
    const [termoCadastro, setTermoCadastro] = useState("");
    const [possuiTermo, setPossuiTermo] = useState(false);
    const [aceitouTermo, setAceitouTermo] = useState(false);

    //Categorias
    const [categorias, setCategorias] = useState([]);

    //Campos de validação para o passo de identificação
    const camposIdentificacao = [
        objCampo({ name: "cpfcnpj", required: true, cpfcnpj: true }),
        objCampo({ name: "fantasia", required: true }),
        objCampo({ name: "razao", required: true }),
        objCampo({ name: "email", required: true, email: true }),
        objCampo({ name: "contato", required: true }),
        objCampo({ name: "fone", required: true }),
        objCampo({ name: "tbSegmentos_Id", required: true }),
        objCampo({ name: "categoria", required: true }),
        objCampo({ name: "tbPrefeituras_id", required: true }),

    ]

    useEffect(() => {
        const pendenteAnalise = geradorParam?.localidades?.some(x => x.status === "Pendente");
        if (pendenteAnalise) {
            showMessage("Aviso", "Este gerador possui uma solicitação de cadastro pendente de análise.", "error", null);
        }
        if (setupVariavel?.quemCadastraGeradores == "Gerador" ||
            setupVariavel?.quemCadastraGeradores == "Secretaria/Gerador" ||
            setupVariavel?.quemCadastraGeradores == "Secretaria/Transportador/Gerador") {
            if (setupVariavel?.quemCadastraGeradores == "Secretaria/Transportador/Gerador" && session?.acesso?.sigla == "TR") {
                setDisbleCampos(false);
            } else if (session?.acesso?.sigla == "TR") {
                setDisbleCampos(true);
            }
            if (session?.acesso?.sigla == "GG") {
                setDisbleCampos(false);
            }
            if (!session) {
                setDisbleCampos(false);
            }
            if (session?.acesso?.sigla == "GS")
                setDisbleCampos(false);
        } else if (session?.acesso?.sigla != "GG") {
            if (session?.acesso?.sigla === "TR" && integracaoCadastros) {
                setDisbleCampos(true);
            }
            else {
                setDisbleCampos(false);
            }
        } else {
            setDisbleCampos(true);
        }
    }, [setupVariavel, session, geradorParam]);

    //Função de validação dos campos de identificação do gerador
    function validarDadosGerador() {
        let _camposIdentificacao = camposIdentificacao;
        if (gerador.id)
            _camposIdentificacao = camposIdentificacao.filter(x => x.name != "cpfcnpj");

        const erros = validarCampos(gerador, _camposIdentificacao);
        setErrors(erros[0]);
        return erros[1];
    }

    //Função que valida os dados do Endereço
    function validarDadosEndereco() {
        const _gerador = { ...gerador };
        const localidades = _gerador.localidades

        if (localidades.length == 0) {
            showMessage("Aviso", "É obrigatório informar ao meno um endereço", "warning", null);
            return ["Para poder cadastrar um novo gerador é necessario ter ao menos um endereço"];
        }
    }

    //Valida os dados dos contratos
    function validarContratos() {
        if (!gerador.id && session.acesso.modulo === "Transportador") {
            const localidadesComContratoAtivo = gerador.localidades.filter(value => {
                return value.contratos.filter(contrato => contrato.situacaoContrato === "Ativo").length > 0;
            });
            if (localidadesComContratoAtivo.length === 0) {
                showMessage("Aviso", "Para poder cadastrar um novo gerador é necessario ter ao menos um contrato ativo", "info", null);
                return ["Para poder cadastrar um novo gerador é necessario ter ao menos um endereço com um contrato ativo"];
            }
        }
    }

    //Change para a identificação do gerador
    const onChangeGerador = (e) => {
        const { name, value } = e.target;
        const _gerador = { ...gerador, [name]: value };

        if (name === "categoria") {
            const cat = categorias.find(c => c.descricao === value);
            _gerador.aprovacaoAutomaticaCategoria = cat ? cat.aprovacaoAutomatica : false;
            _gerador.tbGeradoresCategorias_Id = cat ? cat.id?.toString() ?? null : null;
        }

        const campos = camposIdentificacao.filter(value => value.name === name);
        const erros = validarCampos(_gerador, campos);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setGerador(_gerador);
    }

    function onChangeDocumentos(documento) {
        const _gerador = { ...gerador };
        const existeDocumento = _gerador.documentos.findIndex(x => x.tbDocumentos_Id === documento.tbDocumentos_Id);

        if (existeDocumento === -1) {
            _gerador.documentos = [..._gerador.documentos, {
                ...documento,
                tbGerador_Id: gerador.id ? gerador.id : null
            }];
        } else {
            _gerador.documentos[existeDocumento] = {
                ..._gerador.documentos[existeDocumento],
                ...documento
            };
        }
        setGerador(_gerador);
    }

    const validarDocumentos = () => {
        const documentosObrigatorios = listdocumentos.filter(doc => doc.obrigatorio);
        const todosDocumentosPresentes = documentosObrigatorios.every(obrigatorioDoc =>
            gerador?.documentos?.some(doc => doc.tbDocumentos_Id === obrigatorioDoc.id)
        );
        if (documentosObrigatorios.length > 0 && !todosDocumentosPresentes) {
            showMessage("Aviso", "Existe documento obrigatório que precisa ser informado", "warning", null);
            return ["Informe todos os documentos obrigatórios para este gerador!"];
        }
        return null;
    };

    const showAddEndereco = () => {
        if (integracaoCadastros) return null
        if (session?.ambiente === "Público" && session?.acesso?.sigla === "GG" && setupVariavel?.quemCadastraGeradores === "Gerador") return () => setOpenEnderecos(!openEnderecos)
        if (session?.ambiente === "Público" && (session?.acesso?.sigla === "TR" || session?.acesso?.sigla === "GS") && setupVariavel?.quemCadastraGeradores !== "Gerador") return () => setOpenEnderecos(!openEnderecos)
        if (session?.ambiente === "Privado" && (session?.acesso?.sigla === "TR" || session?.acesso?.sigla === "GS")) return () => setOpenEnderecos(!openEnderecos)
        if ((setupVariavel?.quemCadastraGeradores === "Gerador" || setupVariavel?.quemCadastraGeradores === "Secretaria/Gerador" || setupVariavel?.quemCadastraGeradores === "Secretaria/Transportador/Gerador") && !session) return () => setOpenEnderecos(!openEnderecos)
        return null
    }

    //Função de validação do step de aceite de termo
    function validarTermo() {
        if (possuiTermo && !aceitouTermo) {
            showMessage("Aviso", "É obrigatório aceitar o termo de ciência para concluir o cadastro.", "warning", null);
            return ["Aceite do termo obrigatório"];
        }
    }

    //Função para pegar os passos do cadastro/edição
    const steps = [
        { text: "Identificação do gerador", icon: faPencilAlt, validateStep: validarDadosGerador },
        { text: "Endereços", icon: faMapMarkerAlt, btnAdicionar: showAddEndereco(), validateStep: validarDadosEndereco },
        ...cadastroExternoGerador == false ? [
            { text: "Contratos", icon: faFile, validateStep: validarContratos }
        ] : [],
        ...listdocumentos.length > 0 ? [
            { text: "Documentos", icon: faFilePdf, validateStep: validarDocumentos }
        ] : [],
        ...(cadastroExternoGerador && possuiTermo) ? [
            { text: "Declaração", icon: faFileSignature, validateStep: validarTermo }
        ] : [],
        { text: "Finalizar", icon: faCheck }
    ];

    function loadDocumentos(categoria) {
        if (!categoria) {
            setListDocumentos([]);
            return;
        }
        setLoading(true);
        documento_api.GetListPorCategoriaNome(categoria).then(response => {
            if (response.data?.length === 0) {
                setListDocumentos([]);
            } else {
                const _documentos = response.data.map(value => ({
                    id: value.id,
                    identificacao: value.identificacao,
                    descricao: value.descricao,
                    obrigatorio: value.obrigatorio
                }));

                setListDocumentos(_documentos);

                // Remove documentos anexados que não pertencem mais à categoria atual
                const idsPermitidos = new Set(_documentos.map(d => d.id));
                const documentosMantidos = (gerador.documentos ?? []).filter(
                    d => idsPermitidos.has(d.tbDocumentos_Id)
                );

                if (documentosMantidos.length !== (gerador.documentos ?? []).length) {
                    setGerador(prev => ({ ...prev, documentos: documentosMantidos }));
                }
            }
        }).catch(e => showMessage("Aviso", e.message, "error"))
            .finally(f => setLoading(false));
    }

    //Função para pegar o passo ativo do cadastro/edição
    function getStep() {
        switch (steps[activeStep - 1].text) {
            case "Identificação do gerador":
                return <IdentificacaoGerador
                    gerador={{ ...gerador, editFicha: !disabledCampos }}
                    disabledCampos={disabledCampos}
                    setGerador={setGerador}
                    errors={errors}
                    onChangeGerador={onChangeGerador}
                    integracaoCadastros={integracaoCadastros}
                />
            case "Endereços":
                return <Enderecos
                    errors={errors}
                    disabledCampos={disabledCampos}
                    gerador={{ ...gerador, editFicha: !disabledCampos }}
                    setGerador={setGerador}
                    openForm={openEnderecos}
                    setOpenForm={setOpenEnderecos}
                    modulo={session?.acesso?.modulo}
                    integracaoCadastros={integracaoCadastros}
                />
            case "Contratos":
                return (
                    <>
                        <Contratos
                            gerador={gerador}
                            setGerador={setGerador}
                            openForm={openContratos}
                            setOpenForm={setOpenContratos}
                            integracaoCadastros={integracaoCadastros}
                        />
                    </>
                )
            case "Documentos":
                return (
                    <Documentos
                        documentos={listdocumentos}
                        onChangeDocumentos={onChangeDocumentos}
                        state={gerador}
                        disabledCampos={disabledCampos}
                    />
                )
            case "Declaração":
                return (
                    <TermoCienciaGerador
                        termoHtml={termoCadastro}
                        aceitou={aceitouTermo}
                        onChangeAceitou={setAceitouTermo}
                        errors={errors}
                    />
                )
            case "Finalizar":
                return (
                    <>
                        <p className='ms-3'>Confira se todos os dados estão corretos</p>
                        <FichaGeradorContainer
                            modulo={session?.acesso?.modulo}
                            gerador={gerador}
                            enderecos={gerador.localidades}
                            vistorias={gerador.vistorias}
                            editGerador={() => setActiveStep(1)}
                            editEnderecos={() => setActiveStep(2)}
                            integracaoCadastros={integracaoCadastros}
                            cadastroExternoGerador={cadastroExternoGerador}
                        />
                    </>
                )
        }
    }

    //Função para enviar os dados para a api cadastrar/editar no banco
    async function onSubmit() {
        const _gerador = { ...gerador };
        _gerador.localidades = _gerador.localidades.map(localidade => {
            const _localidade = { ...localidade };
            _localidade.contratos = [..._localidade.contratos];
            _localidade.contratos = _localidade.contratos.filter(contrato => {
                return !(contrato.situacaoContrato === "Sem Contrato" && contrato.id === 0);
            });
            _localidade.contratos = _localidade.contratos.map(contrato => {
                contrato.editContrato = true;
                if (!contrato.quantidadeContratada) {
                    contrato.quantidadeContratada = 0;
                } else {
                    contrato.quantidadeContratada = contrato.quantidadeContratada.toString().replace(",", ".")
                }
                return { ...contrato };
            })
            return _localidade;
        })

        let _documentos = [...gerador.documentos];
        delete _gerador.documentos;

        setLoading(true);

        try {
            let res;
            if (!_gerador.id) {
                res = await gerador_api.Post({ ..._gerador, aceitouTermoCadastro: aceitouTermo });
                _documentos = _documentos.map(doc => ({
                    ...doc,
                    tbGerador_Id: res.data.id
                }));
                await gerador_api.PostDocumentos(_documentos);
                showMessage("Sucesso", "Gerador cadastrado com sucesso", "success", () => {
                    if (cadastroExternoGerador) {
                        navigate("/auth/login")
                    } else {
                        btnVoltar()
                    }
                });

            } else {
                res = await gerador_api.Put(_gerador);
                _documentos = _documentos.map(doc => ({
                    ...doc,
                    tbGerador_Id: res.data.id
                }));
                await gerador_api.PostDocumentos(_documentos);
                showMessage("Sucesso", "Gerador editado com sucesso", "success", btnVoltar);
            }
        } catch (error) {
            const message = error.message ? error.message || "Erro ao conectar com API" : "Erro ao conectar com API";
            showMessage("Erro", message, "error");
        } finally {
            setLoading(false);
        }
    }

    async function loadCategorias(e) {
        try {
            const response = await geradoresCategoria_api.GetListAtivos();
            setCategorias(response.data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        loadCategorias();
    }, []);

    //Carrega o termo de ciência da prefeitura (apenas no auto-cadastro anônimo)
    useEffect(() => {
        if (cadastroExternoGerador && !session && gerador.tbPrefeituras_id) {
            prefeitura_api.GetTermoCadastroGerador(gerador.tbPrefeituras_id)
                .then(response => {
                    setPossuiTermo(response.data.possuiTermo);
                    setTermoCadastro(response.data.termoAceite ?? "");
                    setAceitouTermo(false);
                })
                .catch(() => {
                    setPossuiTermo(false);
                    setTermoCadastro("");
                });
        }
    }, [gerador.tbPrefeituras_id]);

    useEffect(() => {
        loadDocumentos(gerador.categoria);
    }, [gerador.categoria])


    return (
        <>
            <MainCard btnVoltar={btnVoltar}>
                <Row className='mb-4'>
                    <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                </Row>
                <Stepper activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} onSubmit={onSubmit}>
                    {getStep()}
                </Stepper>
            </MainCard>
        </>
    )

}